/** @typedef {import('../models/photo-entity').default} PhotoEntity */

import { PHOTO_TITLE } from "../constants"

export default class TitleElement {
  /**
   * @static
   * @param {HTMLElement} htmlElement
   * @memberof TitleElement
   */
  static fromHtmlElement(htmlElement) {
    return new TitleElement(htmlElement.querySelector(PHOTO_TITLE))
  }

  /**
   * Creates an instance of TitleElement.
   * @param {HTMLElement} element
   * @memberof TitleElement
   */
  constructor(element) {
    this.element = element
  }

  /**
   * @param {PhotoEntity} photo
   * @memberof TitleElement
   */
  apply(photo) {
    this.element.textContent = photo.title
  }
}
